
export default function Hero() {
  const scrollToOferta = () => {
    const element = document.getElementById('oferta');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-950">
        <img
          src="https://public.readdy.ai/ai/img_res/23223aee3fd5657bf59991b7844419a7.jpg"
          alt="Background"
          className="w-full h-full object-cover opacity-20"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-purple-900/60 via-purple-800/40 to-purple-950/60"></div>
      
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-8 text-center py-32">
        <div className="mb-8">
          <span className="inline-block bg-yellow-400 text-purple-900 px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wide">
            Transforme seu negócio
          </span>
        </div>
        
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Aprenda, execute e Cresça na sua Empresa com Estratégia Real
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-100 mb-10 max-w-3xl mx-auto leading-relaxed">
          Aprenda o método prático para esclarecer sua empresa, criar autoridade e vender mais — sem enrolação, sem fórmulas mágicas.
        </p>
        
        <a
          href="https://pay.kiwify.com.br/gZuAA7n"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-yellow-400 text-purple-900 px-10 py-5 rounded-full text-lg font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 shadow-2xl cursor-pointer inline-flex items-center gap-3 whitespace-nowrap"
        >
          Quero minha vaga agora
          <i className="ri-arrow-right-line text-2xl"></i>
        </a>
        
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-yellow-400 text-2xl"></i>
            <span className="text-sm md:text-base">Método validado</span>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl opacity-60"></i>
      </div>
    </section>
  );
}
